import { AbstractStorage } from './abstract-storage.interface';

/**
 * Local Storage
 *
 * @see https://developer.mozilla.org/ru/docs/Web/API/Window/localStorage
 */
export abstract class LocalStorage extends AbstractStorage {}
